import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ObservationDialogData} from '../../../../../../shared/models/observation-group';
import {FormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatList, MatListItem} from '@angular/material/list';

@Component({
  selector: 'app-delete-observation-group-dialog',
  templateUrl: 'delete-observation-group-dialog.component.html',
  styleUrls: ['delete-observation-group-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIcon,
    MatList,
    MatListItem,
  ]
})
export class DeleteObservationGroupDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteObservationGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObservationDialogData) {
  }

}
